import curry from "./lib/core/functional/curry";
import postControls from "./views/postControls";
import loadRiver from "./views/river/loader";
import loadSiteEdit from "./views/siteEdit/loader";
import loadSideMenu from "./views/sideMenu/loader";
import loadTechnicalHelpers from "./views/technicalHelpers/loader";
import moduleLoader from "./utils/moduleLoader";
import getLoggedInUserInfo from "./transport/loggedInUser";
import { isUltraLightLoggedIn } from "./utils/loggedInControl.js";
import loadExternalStylesheet from "./utils/loadExternalStylesheet.js";
import noop from "./lib/core/functional/noop.js";

function startOfWeek() {
    const d = new Date();
    const day = d.getDay();
    const diff = (day === 0 ? -6 : 1) - day;

    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);

    return d.getTime();
}

function materialIcons(context) {
    if (isUltraLightLoggedIn()) {
        loadExternalStylesheet(
            "https://fonts.googleapis.com/icon?family=Material+Icons",
            noop,
            noop
        );
    }

    loadExternalStylesheet(
        `/static/css-build/roar/runner/base/user-prefs.css?ts=${startOfWeek()}`,
        noop,
        noop
    );
    return context;
}

const moduleList = [
    materialIcons,
    postControls,
    loadRiver,
    loadSiteEdit,
    loadSideMenu,
    loadTechnicalHelpers,
];

const propagateData = curry(function propagateData(data, [resolve]) {
    resolve(data);
});

const propagateError = curry(function propagateError(error, [_, reject]) {
    reject(error);
});

export default function upgradeToLoggedIn(context, waiters, listeners) {
    let gettingLoggedIn = false;

    function propagate(err, data) {
        if (err) {
            waiters.forEach(propagateError(err));
        } else {
            waiters.forEach(propagateData(data));
        }
        waiters.length = 0;
        gettingLoggedIn = false;
    }

    function addToWaiters(resolve, reject) {
        waiters.push([resolve, reject]);
    }

    function getUserInfo(forceNew) {
        if (gettingLoggedIn) {
            return new Promise(addToWaiters);
        }
        gettingLoggedIn = true;

        return getLoggedInUserInfo(forceNew)
            .then((data) => {
                propagate(null, data);
                return data;
            })
            .catch((err) => {
                propagate(err);
                throw err;
            });
    }

    function listenForUserInfo(cb) {
        listeners.push(cb);
        getUserInfo()
            .then((data) => {
                cb(null, data);
            })
            .catch((err) => {
                cb(err, null);
            });
    }

    function refreshUserInfo() {
        getUserInfo(true)
            .then((data) => {
                listeners.forEach((listener) => listener(null, data));
            })
            .catch((err) => {
                listeners.forEach((listener) => listener(err, null));
            });
    }

    context.getUserInfo = getUserInfo;
    context.listenForUserInfo = listenForUserInfo;
    context.refreshUserInfo = refreshUserInfo;

    if (listeners.length) {
        refreshUserInfo();
    }

    return moduleLoader(moduleList, context);
}
